<template>
  <v-card pa-3 class="card">
    <section>
      <div :id="pageTopId" class="gallery-wrapper mb-3">
        <div class="gallery-image-viewer">
          <img :src="galleryImages[selectedGalleryImageIndex]" />
        </div>

        <v-layout row mt-2 class="gallery-image-selector">
          <v-flex
            v-for="(image, i) in galleryImages"
            :key="image"
            xs3
            class="gallery-image-selector-item"
          >
            <img :src="image" @click="onSelectGalleryImage(i)" />
            <div v-if="i === selectedGalleryImageIndex" class="overlay"></div>
          </v-flex>
        </v-layout>
      </div>

      <h3>連絡帳製本</h3>

      <p v-if="priceCombookBinding" class="mt-2">
        {{ priceCombookBinding }}円（税込）
      </p>
      <p class="mt-2">
        日々書き留めた連絡帳の記録を、たったひとつの特別な本として製本します。<br />
        お子さまのかけがえのない瞬間が詰まった一冊は、いつでも手にとって読み返すことができる大切な宝物となります。<br />
        愛おしい想い出を形に残しませんか？
      </p>
      <a
        href=""
        class="bold"
        @click.prevent="$emit('show-binding-sample-dialog')"
        >サンプルを確認する</a
      >

      <v-divider class="my-3"></v-divider>

      <h3>詳細仕様</h3>

      <div class="image-wrapper">
        <img
          :src="
            require('../../assets/images/combook_binding/product_detail/sample_cover.png')
          "
          alt="表紙と背表紙"
        />
      </div>

      <CoverSpecTable />

      <v-divider class="my-3"></v-divider>

      <h3>表紙デザイン</h3>

      <div class="image-wrapper">
        <v-layout row justify-center>
          <v-flex xs6 mx-2>
            <img
              :src="
                require('../../assets/images/combook_binding/product_detail/sample_cover_design_pastel.png')
              "
              alt="表紙デザイン(パステル)"
            />
          </v-flex>
          <v-flex xs6 mx-2>
            <img
              :src="
                require('../../assets/images/combook_binding/product_detail/sample_cover_design_simple.png')
              "
              alt="表紙デザイン(シンプル)"
            />
          </v-flex>
        </v-layout>
      </div>

      <p>
        2つの表紙デザインをご用意しております。大切な想い出にぴったりのデザインをお選びください。
      </p>

      <v-divider class="my-3"></v-divider>

      <h3>登園日の項目</h3>

      <div class="image-wrapper">
        <img
          :src="
            require('../../assets/images/combook_binding/product_detail/sample_pages_present_day.png')
          "
          alt="登園日の項目"
        />
      </div>

      <table class="combook-binding-item-description mb-4">
        <thead>
          <th></th>
          <th>家庭から</th>
          <th>園・施設から</th>
        </thead>
        <tbody>
          <tr>
            <th>送信者</th>
            <td>送信者</td>
            <td>送信者</td>
          </tr>
          <tr>
            <th>機嫌</th>
            <td>登録内容</td>
            <td>登録内容</td>
          </tr>
          <tr>
            <th>体温</th>
            <td>平均体温</td>
            <td>平均体温</td>
          </tr>
          <tr>
            <th>便</th>
            <td>最新を1件</td>
            <td>最新を1件</td>
          </tr>
          <tr>
            <th>ミルク</th>
            <td>合計量</td>
            <td>合計量</td>
          </tr>
          <tr>
            <th>授乳</th>
            <td>合計回数</td>
            <td>✕</td>
          </tr>
          <tr>
            <th>睡眠</th>
            <td>合計時間</td>
            <td>合計時間</td>
          </tr>
          <tr>
            <th>食事</th>
            <td>食事時間</td>
            <td>✕</td>
          </tr>
          <tr>
            <th>連絡欄</th>
            <td>全角700文字まで表示（改行を省く）</td>
            <td>全角700文字まで表示（改行を省く）</td>
          </tr>
          <tr>
            <th>連絡帳写真</th>
            <td>非表示</td>
            <td>写真あり 最大3枚</td>
          </tr>
        </tbody>
      </table>

      <p>
        ※
        上記の項目は、園・施設によって記録内容が異なります。記録を行っていない項目は表示されません。
      </p>
      <p>
        ※
        連絡帳製本のデイリーページ連絡欄で利用されている記号や絵文字、環境依存文字は、文字化け・別の文字に置き換わる可能性があります。
        予めご了承ください。詳しい非対応文字は
        <a
          href="https://lookmee.tayori.com/q/lookmee-faq-c/detail/1168352/"
          target="_blank"
          rel="noopener"
          >よくある質問<v-icon small color="primary">open_in_new</v-icon></a
        >をご確認ください。
      </p>

      <v-divider class="my-3"></v-divider>

      <h3>欠席日の項目</h3>

      <div class="image-wrapper">
        <img
          :src="
            require('../../assets/images/combook_binding/product_detail/sample_pages_absent_day.png')
          "
          alt="欠席日の項目"
        />
      </div>

      <table class="combook-binding-item-description mb-4">
        <thead>
          <th></th>
          <th>家庭から</th>
          <th>園・施設から</th>
        </thead>
        <tbody>
          <tr>
            <th>欠席</th>
            <td>欠席理由</td>
            <td>✕</td>
          </tr>
          <tr>
            <th>連絡欄</th>
            <td>全角700文字まで表示（改行を省く）</td>
            <td>✕</td>
          </tr>
        </tbody>
      </table>

      <v-divider class="my-3"></v-divider>

      <h3>メモページ</h3>

      <div class="image-wrapper">
        <img
          :src="
            require('../../assets/images/combook_binding/product_detail/sample_pages_memo.png')
          "
          alt="メモページ"
        />
      </div>

      <p>
        メモページは、お子さまの成長や思い出のメモを残したり、写真を貼ったり等ご自由にお使いください。
      </p>
    </section>
  </v-card>
</template>

<script>
import CoverSpecTable from "packs/site/pages/combook_binding/components/Tables/CoverSpecTable.vue";

export default {
  components: {
    CoverSpecTable
  },
  props: {
    pageTopId: {
      type: String,
      required: true
    },
    selectedGalleryImageIndex: {
      type: Number,
      default: 0
    },
    priceCombookBinding: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      galleryImages: [
        require("../../assets/images/combook_binding/product_detail/gallery_1.png"),
        require("../../assets/images/combook_binding/product_detail/gallery_2.png"),
        require("../../assets/images/combook_binding/product_detail/gallery_3.png"),
        require("../../assets/images/combook_binding/product_detail/gallery_4.png")
      ]
    };
  },
  methods: {
    onSelectGalleryImage(index) {
      this.$emit("update:selectedGalleryImageIndex", index);
    }
  }
};
</script>

<style scoped>
.card {
  padding-top: 56px !important; /* toolbarの高さを考慮して、パディングを追加 */
  background-color: #ffffff;
}
.card section {
  max-width: 443px;
  padding: 16px;
  margin: 0 auto;
}
a.bold {
  font-weight: bold;
}

.gallery-image-viewer img {
  box-sizing: border-box;
  border: 1px solid #eaeae8;
  border-radius: 4px;
}

.gallery-image-selector {
  gap: 8px;
}

.gallery-image-selector-item {
  position: relative;
}
.gallery-image-selector-item img {
  display: block;
  width: 100%;
  height: auto;

  box-sizing: border-box;
  border: 1px solid #eaeae8;
  border-radius: 4px;
}

.gallery-image-selector-item .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  box-sizing: border-box;
  border: 1px solid #4cb5b8;
  background-color: #0000001f;

  z-index: 1; /* toolbarのz-indexが2なので-1して1にしている */
}

.image-wrapper {
  padding: 24px 16px 16px 16px;
  margin: 16px 0px;
  box-sizing: border-box;
  background: #f3f2f1;
  border-radius: 4px;
}

table.combook-binding-item-description {
  width: 100%;
  table-layout: fixed;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  border-collapse: collapse;
  font-size: 12px;
  line-height: 150%;
}

table.combook-binding-item-description thead th {
  padding: 8px;
  max-width: 130px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: #f5f5f5;
  text-align: center;
}

table.combook-binding-item-description thead th:first-child {
  width: 84px;
}

table.combook-binding-item-description tbody th,
td {
  padding: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

table.combook-binding-item-description tbody th {
  width: 88px;
  background: #f5f5f5;
  text-align: left;
}

table.combook-binding-item-description tbody td {
  background: #ffffff;
  text-align: center;
}
</style>
